export default {
      id: "share-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#share",
      toString: function () {
        return this.url;
      }
    }